/* eslint-disable max-len */
export default {
  header: '',
  item:
    '<a class="{{cssClasses.link}}" href="{{url}}">{{label}} <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span></a>',
  footer: '',
};



// WEBPACK FOOTER //
// ./src/widgets/menu/defaultTemplates.js